import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError, AxiosInstance } from 'axios';
import { addActionNameToMutationResult } from 'shared/hooks/utils/add-action-name-to-mutation-result';
import { useAxiosInstance } from 'shared/hooks/utils/axios-instance';
import type { ApiResponse } from 'shared/hooks/utils/types';

export type UpdateExcludedAccountsVariables = Array<string>;

export async function updateExcludedAccounts(
  axiosInstance: Promise<AxiosInstance>,
  data: UpdateExcludedAccountsVariables,
) {
  const instance = await axiosInstance;
  return instance.put('accounting_details/excluded_account_numbers', data);
}

export function useUpdateExcludedAccounts() {
  const axiosInstance = useAxiosInstance();
  const client = useQueryClient();

  const mutation = useMutation<
    ApiResponse,
    AxiosError<{ error_message: Array<string> }>,
    UpdateExcludedAccountsVariables
  >({
    mutationFn: variables => updateExcludedAccounts(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['company-configuration'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    AxiosError<{ error_message: Array<string> }>,
    UpdateExcludedAccountsVariables,
    'updateExcludedAccounts'
  >('updateExcludedAccounts', mutation);
}
